import React, { useState } from "react";
import {
  Box, Input, Textarea, Select, FormControl, FormLabel, Grid, GridItem,
  Button, Heading, VStack, HStack,
  theme
} from "@chakra-ui/react";
import DataTable from "./AppDataTable";
import * as IconButton from "../themes/IconButtonSet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines, faSyringe, faTable } from "@fortawesome/free-solid-svg-icons";
import CustomDatePicker from "./CustomDatePicker"; // นำเข้า CustomDatePicker
import ApiService from "../services/ApiService"; // นำเข้า ApiService
import { StandardPageTitle, StandardHeader } from "../themes/StandardHeader";

const VaccineReserveByFarmer = () => {
  const [documentHeader, setDocumentHeader] = useState({
    requisitionNumber: "REQ-2567-08-001",
    deliverytime: "20-25 ธันวาคม 2567",
    documentDate: null,
    department: "แผนกสัตวแพทย์",
    warehouse: "ปศุสัตว์จังหวัดนครราชสีมา",
    referenceDocumentType: "ใบสั่งจองวัคซีน",
    referenceDocumentNumber: "ORD-2023-005",
    purchaseOrderNumber: "PO-2023-010",
    warehouseStaff: "นายสมชาย ใจดี",
  });

  const [selectedVaccines, setSelectedVaccines] = useState([
    {
      id: "V001",
      name: "วัคซีนป้องกันโรคไข้หวัดนก (Avian Influenza Vaccine)",
      quantity: 10,
      confirmqty: "",
      lot: "LT0002",
      location: "LC3-01",
      uop: "350",
      unit: "ขวด",
      totalcost: "3,500",
    },
    {
      id: "V003",
      name: "วัคซีนป้องกันโรคพิษสุนัขบ้า (Rabies Vaccine)",
      quantity: 20,
      confirmqty: "",
      lot: "LT0172",
      location: "LC7-14",
      uop: "300",
      unit: "ขวด",
      totalcost: "6,000",
    },
    {
      id: "V005",
      name: "วัคซีนโรคปากและเท้าเปื่อย (FMD Vaccine)",
      quantity: 15,
      confirmqty: "",
      lot: "LT0092",
      location: "LC9-06",
      uop: "350",
      unit: "ขวด",
      totalcost: "5,250",
    },
  ]);

  const [newVaccine, setNewVaccine] = useState({
    id: "",
    quantity: "",
  });

  const vaccineOptions = [
    { id: "V001", name: "วัคซีนป้องกันโรคไข้หวัดนก (Avian Influenza Vaccine)" },
    { id: "V002", name: "วัคซีนโรคฝีดาษไก่ (Fowl pox Vaccine)" },
    { id: "V003", name: "วัคซีนป้องกันโรคพิษสุนัขบ้า (Rabies Vaccine)" },
    { id: "V004", name: "วัคซีนโรคแอนแทรกซ์ (Anthrax Vaccine)" },
    { id: "V005", name: "วัคซีนโรคปากและเท้าเปื่อย (FMD Vaccine)" },
    { id: "V006", name: "วัคซีนโรคแบล็คเลก (Blackleg Vaccine)" },
  ];

  const handleHeaderChange = (e) => {
    const { name, value } = e.target;
    setDocumentHeader({ ...documentHeader, [name]: value });
  };

  const handleDateChange = (date) => {
    setDocumentHeader({ ...documentHeader, documentDate: date });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewVaccine({ ...newVaccine, [name]: value });
  };

  const handleAddVaccine = () => {
    if (newVaccine.id && newVaccine.quantity > 0) {
      const selectedVaccine = vaccineOptions.find((v) => v.id === newVaccine.id);
      if (selectedVaccine) {
        const uop = "350";
        const totalCost = (parseInt(newVaccine.quantity) * parseInt(uop)).toString();

        const vaccineData = {
          id: newVaccine.id,
          name: selectedVaccine.name,
          quantity: newVaccine.quantity,
          confirmqty: "",
          lot: `LT${Date.now().toString().slice(-4)}`,
          location: "LC1-01",
          uop: uop,
          unit: "ขวด",
          totalcost: totalCost,
        };

        setSelectedVaccines([...selectedVaccines, vaccineData]);
        setNewVaccine({ id: "", quantity: "" });
      }
    }
  };

  const handleRemoveVaccine = (row) => {
    setSelectedVaccines(selectedVaccines.filter((v) => v.id !== row.id));
  };

  const handleConfirm = async () => {
    const date = documentHeader.documentDate;
    const formattedDate = date ? `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear()}` : "";
    const currentDocument = {
      id: documentHeader.requisitionNumber,
      ...documentHeader,
      documentDate: formattedDate,
      vaccines: selectedVaccines,
    };

    try {
      const data = await ApiService({
        method: "POST",
        url: "http://192.168.1.190:3003/reserve-vaccine", // สมมติ URL API
        data: currentDocument,
      });
      console.log("API Response:", data);
    } catch (error) {
      console.error("API Error:", error.message);
    }
  };

  const columns = [
    { name: "รหัสวัคซีน", selector: (row) => row.id, sortable: true },
    { name: "ชื่อวัคซีน", selector: (row) => row.name, sortable: true },
    { name: "จำนวนที่สั่งจอง", selector: (row) => row.quantity, sortable: true },
    { name: "จำนวนที่ได้รับจอง", selector: (row) => row.confirmqty || "-", sortable: true },
    { name: "ราคาต่อหน่วย", selector: (row) => row.uop, sortable: true },
    { name: "หน่วยบรรจุ", selector: (row) => row.unit, sortable: true },
    { name: "มูลค่ารวม", selector: (row) => row.totalcost, sortable: true },
    {
      name: "การดำเนินการ",
      cell: (row) => (
        <IconButton.DeleteIcon onClick={() => handleRemoveVaccine(row)} size="sm" />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <Box p={35} m={25} borderWidth={1} borderRadius="lg" boxShadow="lg">
      <StandardPageTitle title="รายการสั่งจองวัคซีน" />

      {/* Box 1: ข้อมูลเอกสารการสั่งจองวัคซีน */}
      <Box borderWidth={1} borderRadius="lg" boxShadow="lg" p={5} mb={6}>
        <StandardHeader
          title="ข้อมูลเอกสารการสั่งจองวัคซีน"
          bgColor="iBlue.600"
          icon={faFileLines}
        />
        <Grid templateColumns="repeat(4, 1fr)" gap={6} p={5}>
          <GridItem colSpan={1}>
            <FormControl>
              <FormLabel fontSize="xl" color="gray">เลขที่ใบสั่งจองวัคซีน</FormLabel>
              <Input name="requisitionNumber" value={documentHeader.requisitionNumber} onChange={handleHeaderChange} colorScheme="iBlue"/>
            </FormControl>
          </GridItem>
          <GridItem colSpan={1}>
            <FormControl>
              <FormLabel fontSize="xl" color="gray">รอบการจัดส่งวัคซีน</FormLabel>
              <Input name="deliverytime" value={documentHeader.deliverytime} onChange={handleHeaderChange} colorScheme="iBlue"/>
            </FormControl>
          </GridItem>
          <GridItem colSpan={1}>
            <FormControl>
              <FormLabel fontSize="xl" color="gray">วันที่เอกสาร</FormLabel>
              <CustomDatePicker
                value={documentHeader.documentDate}
                onChange={handleDateChange}
                colorScheme="iBlue"
              />
            </FormControl>
          </GridItem>
          <GridItem colSpan={1}>
            <FormControl>
              <FormLabel fontSize="xl" color="gray">จุดจำหน่ายที่ต้องการรับวัคซีน</FormLabel>
              <Input name="warehouse" value={documentHeader.warehouse} onChange={handleHeaderChange} colorScheme="iBlue"/>
            </FormControl>
          </GridItem>
          <GridItem colSpan={2}>
            <FormControl>
              <FormLabel fontSize="xl" color="gray">ชื่อเกษตรกร</FormLabel>
              <Input name="department" value="นายฟาร์มเมอร์ แสนสุข" onChange={handleHeaderChange} colorScheme="iBlue"/>
            </FormControl>
          </GridItem>
          <GridItem colSpan={1}>
            <FormControl>
              <FormLabel fontSize="xl" color="gray">เบอร์โทรติดต่อ</FormLabel>
              <Input name="referenceDocumentType" value="081-972-3655" onChange={handleHeaderChange} colorScheme="iBlue"/>
            </FormControl>
          </GridItem>
          <GridItem colSpan={1}>
            <FormControl>
              <FormLabel fontSize="xl" color="gray">E-mail Address</FormLabel>
              <Input name="warehouseStaff" value="farmer@test.com" onChange={handleHeaderChange} colorScheme="iBlue"/>
            </FormControl>
          </GridItem>
          <GridItem colSpan={4}>
            <FormControl mb={4}>
              <FormLabel fontSize="xl" color="gray">วัตถุประสงค์การใช้งาน / รายละเอียดเพิ่มเติม</FormLabel>
              <Textarea placeholder="" colorScheme="iBlue"/>
            </FormControl>
          </GridItem>
          <GridItem colSpan={4}>
            <FormControl>
              <FormLabel fontSize="xl" color="gray">สถานะรายการ</FormLabel>
              <Input
                name="status"
                color="gray"
                value="รายการจองใหม่ / ระหว่างดำเนินการตรวจสอบข้อมูล / ยืนยันการจอง / ยกเลิกการจอง / จัดส่งแล้ว"
                onChange={handleHeaderChange}
                colorScheme="iBlue"
              />
            </FormControl>
          </GridItem>
        </Grid>
      </Box>

      {/* Box 2: เลือกวัคซีนที่ต้องการสั่งจอง */}
      <Box borderWidth={1} borderRadius="lg" boxShadow="lg" p={5} mb={6}>
        <Box mb={5} borderRadius="full" w="100%" bgColor="iPurple.500" color="white" p={2}>
          <HStack spacing={5} ml={5}>
            <FontAwesomeIcon icon={faSyringe} color="white" size="xl" />
            <Heading size="lg" fontWeight="normal">เลือกวัคซีนที่ต้องการสั่งจอง</Heading>
          </HStack>
        </Box>
        <Grid templateColumns="repeat(3, 1fr)" gap={6} p={5}>
          <FormControl>
            <FormLabel fontSize="xl" color="gray">เลือกวัคซีน</FormLabel>
            <Select
              name="id"
              value={newVaccine.id}
              onChange={handleInputChange}
              placeholder="เลือกวัคซีน"
              colorScheme="iPurple"
            >
              {vaccineOptions.map((vaccine) => (
                <option key={vaccine.id} value={vaccine.id}>
                  {vaccine.name}
                </option>
              ))}
            </Select>
          </FormControl>
          <FormControl>
            <FormLabel fontSize="xl" color="gray">จำนวน</FormLabel>
            <Input
              name="quantity"
              type="number"
              value={newVaccine.quantity}
              onChange={handleInputChange}
              min={1}
              colorScheme="iPurple"
            />
          </FormControl>
          <Box mt={10}>
            <IconButton.Add onClick={handleAddVaccine} h={9}  />
          </Box>
        </Grid>
      </Box>

      {/* Box 3: รายการวัคซีนที่ต้องการสั่งจอง */}
      <Box borderWidth={1} borderRadius="lg" boxShadow="lg" p={5} mb={6}>
        <Box mb={5} borderRadius="full" w="100%" bgColor="iOrange.500" color="white" p={2}>
          <HStack spacing={5} ml={5}>
            <FontAwesomeIcon icon={faTable} color="white" size="xl" />
            <Heading size="lg" fontWeight="normal">รายการวัคซีนที่ต้องการสั่งจอง</Heading>
          </HStack>
        </Box>
        <Box p={5}>
          <DataTable
            columns={columns}
            data={selectedVaccines}
            pagination
            highlightOnHover
            striped
            responsive
          />
        </Box>
      </Box>

      <Box p={5} textAlign="right">
        <IconButton.Confirm onClick={handleConfirm} />
      </Box>
    </Box>
  );
};

export default VaccineReserveByFarmer;